<template>
    <div>
        <rkm-form
            v-if="model"
            ref="RkmForm"
            show-legend
        >

            <rkm-row>
                <rkm-col cols="12">
                    <rkm-form-input
                        :validations="validations.descricao"
                        label="Descrição"
                        v-model="model.descricao"
                        type="text"
                        uppercase
                    />
                </rkm-col>

                <rkm-col cols="12">
                    <rkm-form-input-autocomplete
                        :repository="repositories.procedimento"
                        :requestQueryStringParams="autocompletesResquestParams.queryString"
                        :searchFields="fields.autocompletes.procedimento"
                        :validations="validations.procedimento"
                        label="Procedimento"
                        v-model="model.procedimento"
                    >
                        <template #itemLabel="{ item }">
                            {{ `${item.codigo} - ${item.nome}` }}
                        </template>
                        <rkm-input-group-append slot="append">
                            <rkm-input-group-text>
                                <rkm-form-radio-group v-model="model.searchByApelido">
                                    <rkm-form-radio :value="false">Código / Nome</rkm-form-radio>
                                    <rkm-form-radio :value="true">Apelido</rkm-form-radio>
                                </rkm-form-radio-group>
                            </rkm-input-group-text>
                        </rkm-input-group-append>
                    </rkm-form-input-autocomplete>
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-select
                        :options="form.grupos"
                        text-field="descricao"
                        value-field="id"
                        label="Grupo"
                        v-model="model.grupoId"
                        :validations="validations.grupo"
                        show-default-option
                    >

                        <rkm-input-group-append slot="append">
                                <rkm-button
                                    @click="$refs.Modal.open()"
                                    color="primary"
                                    title="Cadastrar grupo"
                                >
                                    <rkm-icon icon="plus" />
                                </rkm-button>
                            </rkm-input-group-append>
                    </rkm-form-select>
                </rkm-col>

                <rkm-col cols="6">
                    <rkm-form-select
                        :options="form.modulos"
                        text-field="descricao"
                        value-field="id"
                        label="Módulo"
                        v-model="model.moduloId"
                        default-option-text="Todos"
                        show-default-option
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col class="col-min">
                    <rkm-form-checkbox
                        v-model="model.regulada"
                        inline
                    >
                        Regulada
                    </rkm-form-checkbox>
                </rkm-col>

                <rkm-col class="col-min">
                    <rkm-form-checkbox
                        v-model="model.bloqueado"
                        inline
                    >
                        Inativar
                    </rkm-form-checkbox>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <Modal
            ref="Modal"
            @save="loadGrupo"
        />
    </div>
</template>

<script>

// Components.
import Modal from '@/components/transporte-paciente/motivo/components/Modal'

// Mixins.
import { error, repository, stringCase, object } from '@/mixins'

// Vuex.
import { mapActions } from 'vuex'

export default {
    components: {
        Modal,
    },
    computed: {
        autocompletesResquestParams() {

        return {
            queryString: {
                search_by_apelido: this.model.searchByApelido,
            },
        }
    },
    fields() {

        return {
            autocompletes: {
                procedimento: this.model.searchByApelido
                    ? [{ key: 'parametrizacao_procedimento.apelido', searchable: true }]
                    : [{ key: 'nome', searchable: true }, { key: 'codigo', searchable: true }],
            }
        }
    },
    validations() {
        return {
            descricao: { required: true, max: 100 },
            grupo: { required: true },
        }
    },
    },
    created() {

        this.repositories.motivo = this.getConectaSusRepository('transportePaciente.motivo')
        this.repositories.procedimento = this.getConectaSusRepository('sigtap.procedimento'),

        this.load()
    },
    data: () => ({
        repositories: {
            motivo: null,
            procedimento: null,
        },
        form: null,
        model: null,
    }),
    methods: {
        ...mapActions([ 'setLoading', 'unsetLoading' ]),
        convertBooleanToBinary: (valor) => valor ? 1 : 0,
        trataNull: (valor) => valor === undefined || valor == null ? null : valor,
        load() {
            this.setLoading()

            const request = this.id ?
                this.repositories.motivo.edit(this.id) :
                this.repositories.motivo.create()

            request
                .then(({ data }) => this.setData(data.form || null, data.model || null))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        setData(form, model) {
            if (form) {

                this.form = Object.assign(form)
            }

            if (model) {

                this.model = Object.assign(model)
                this.model.bloqueado = this.model.bloqueado == 1
                this.model.regulada = this.model.regulada == 1

                this.model.searchByApelido = false
            }
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid) {
                        this.setLoading()

                        const modelSnakeCase = this.prepareData()

                        const request = modelSnakeCase.id === undefined || modelSnakeCase.id === null ?
                            this.repositories.motivo.store(modelSnakeCase) :
                            this.repositories.motivo.update(modelSnakeCase.id, modelSnakeCase)

                        request
                            .then(response => {
                                this.showSaveNotification()
                                this.$emit('save', response)
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    }
                })
        },
        prepareData() {
            const motivo = this.clone(this.model)

            motivo.id = this.trataNull(motivo.id)

            motivo.bloqueado = this.convertBooleanToBinary(motivo.bloqueado)
            motivo.regulada = this.convertBooleanToBinary(motivo.regulada)

            motivo.codigoProcedimento = motivo.procedimento ? motivo.procedimento.codigo :  null

            delete (motivo.procedimento)
            delete(motivo.searchByApelido)

            return this.camelObjectKeysToSnakeRecursive(motivo)
        },
        loadGrupo(grupo) {

            this.form.grupos.push(grupo)

            this.$nextTick(() => this.model.grupoId = grupo.id)
        },
    },
    mixins: [ error, repository, stringCase, object ],
    props: {
        id: { type: [Number], default: null }
    },
}
</script>